import { render, staticRenderFns } from "./TermsInfoInput.vue?vue&type=template&id=1d2fac14&scoped=true&"
import script from "./TermsInfoInput.vue?vue&type=script&lang=js&"
export * from "./TermsInfoInput.vue?vue&type=script&lang=js&"
import style0 from "./TermsInfoInput.vue?vue&type=style&index=0&id=1d2fac14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2fac14",
  null
  
)

export default component.exports